import {
  Alert,
  Anchor,
  Button,
  PasswordInput,
  Stack,
  TextInput,
  Title,
} from "@mantine/core";
import { type FormEvent, useState } from "react";

import { getCsrfToken, signInAsAdministrator } from "../../shared/api/client.js";
import { AuthPageFrame } from "./AuthPageFrame.js";

export function AdministratorLogin({
  message,
  onSignedIn,
}: {
  readonly message?: string;
  readonly onSignedIn: () => void;
}) {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState<string>();
  const [submitting, setSubmitting] = useState(false);

  async function submit(event: FormEvent<HTMLFormElement>) {
    event.preventDefault();
    setSubmitting(true);
    setError(undefined);
    try {
      const csrfToken = await getCsrfToken();
      await signInAsAdministrator({ email, password }, csrfToken);
      onSignedIn();
    } catch {
      setError("Administrator sign-in was not accepted. Try again or contact support.");
    } finally {
      setSubmitting(false);
    }
  }

  return (
    <AuthPageFrame>
      <form onSubmit={submit}>
        <Stack gap="md">
          <Title order={1}>Administrator sign-in</Title>
          {message || error ? <Alert color="red" role="alert">{error ?? message}</Alert> : null}
          <TextInput
            autoComplete="username"
            label="Email address"
            onChange={(event) => setEmail(event.currentTarget.value)}
            required
            type="email"
            value={email}
          />
          <PasswordInput
            autoComplete="current-password"
            label="Password"
            onChange={(event) => setPassword(event.currentTarget.value)}
            required
            value={password}
            visibilityToggleFocusable
          />
          <Button loading={submitting} type="submit">
            Sign in as administrator
          </Button>
          <Anchor href="/login">Back to Google sign-in</Anchor>
        </Stack>
      </form>
    </AuthPageFrame>
  );
}
